import { motion } from "framer-motion";
import { Star, Clock, MapPin, Phone } from "@phosphor-icons/react";

const STATS = [
  { Icon: Star, value: "5.0", label: "Google rating" },
  { Icon: Clock, value: "24/7", label: "Always open" },
  { Icon: MapPin, value: "20+", label: "Towns covered" },
  { Icon: Phone, value: "1", label: "Call does it all" },
];

export const StatsBand = () => (
  <section data-testid="stats-band" className="bg-ink text-white border-b-2 border-sun">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-2 lg:grid-cols-4 divide-x divide-white/10">
      {STATS.map((s, i) => (
        <motion.div
          key={s.label}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: i * 0.08 }}
          className="flex items-center gap-4 px-4 sm:px-8 py-8"
        >
          <span className="w-11 h-11 shrink-0 bg-sun text-ink flex items-center justify-center">
            <s.Icon weight="fill" size={22} />
          </span>
          <div>
            <p className="font-display font-extrabold text-3xl sm:text-4xl leading-none tracking-tight text-sun">{s.value}</p>
            <p className="text-xs uppercase tracking-[0.15em] text-white/60 mt-1">{s.label}</p>
          </div>
        </motion.div>
      ))}
    </div>
  </section>
);
